var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("q-layout", { attrs: { view: "hHh lpr fFf" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "scroll",
            rawName: "v-scroll",
            value: _vm.scrolled,
            expression: "scrolled"
          }
        ],
        attrs: { id: "app" }
      },
      [
        _vm.user
          ? [
              _c(
                "q-header",
                {
                  staticClass: "bg-white text-grey-8 q-py-xs",
                  attrs: { elevated: "", reveal: _vm.headerReveal }
                },
                [
                  _c("navigation"),
                  _vm._v(" "),
                  _c("q-separator"),
                  _vm._v(" "),
                  _c("searchbar")
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "q-page-container",
                { staticClass: "page-container" },
                [_c("router-view", { staticClass: "q-pa-md" })],
                1
              ),
              _vm._v(" "),
              _c(
                "q-footer",
                { staticClass: "page-footer", attrs: { bordered: "" } },
                [
                  _c("active-watchlist-selector"),
                  _vm._v(" "),
                  _c("virtual-log-builder")
                ],
                1
              ),
              _vm._v(" "),
              _c("dialog-shell")
            ]
          : _vm.publicRoute
          ? [
              _c(
                "q-header",
                {
                  staticClass: "bg-white text-grey-8 q-py-xs",
                  attrs: { elevated: "" }
                },
                [_c("navigation")],
                1
              ),
              _vm._v(" "),
              _c(
                "q-page-container",
                { staticClass: "page-container" },
                [_c("router-view", { staticClass: "q-pa-md" })],
                1
              ),
              _vm._v(" "),
              _c("q-footer"),
              _vm._v(" "),
              _c("dialog-shell")
            ]
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }